import axios from "axios";
import { getSlug, setHrefWithSlugHook } from "../config/routes/guards/slug";
import { MySwal } from "./swal";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use(
  async config => {
    const slug = getSlug();

    config.headers['slug'] = slug;

    if (slug && !(config.url && config.url.endsWith("/validate"))) {
      try {
        const validateResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/validate`,
          {
            headers: {
              'slug': slug,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 422) {
          window.location.href = "/";
        }
        return Promise.reject(error);
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 403) {
      const errorMessage = error.response?.data?.message || 'Anda tidak memiliki akses untuk mengakses halaman/fitur ini.';
      
      MySwal.fire({
        icon: 'error',
        title: 'Akses Ditolak!',
        text: errorMessage,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: 'swal2-noanimation'
        }
      }).then(async () => {
        // Logout immediately
        try {
          const token = localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          if (token) {
            await axios({
              url: '/users/logout',
              method: 'POST',
              headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
              },
            }).catch(() => {
              // Ignore logout API errors
            });
          }
        } catch (err) {
          // Ignore logout errors
        } finally {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          setHrefWithSlugHook('/login');
        }
      });
    }
    
    return Promise.reject(error);
  }
);

export default instance;
